import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Divider,
} from "@mui/material";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import PersonIcon from "@mui/icons-material/Person";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import EventIcon from "@mui/icons-material/Event";
import UpdateIcon from "@mui/icons-material/Update";
import localize from "../../../common/localize";
import { TimeToLeave } from "@mui/icons-material";

const InfoItem = ({ icon, label, value, isComponent }) => (
  <Box display="flex" alignItems="flex-start" gap={1.5} mb={2}>
    {icon}
    <Box>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>

      {!isComponent ? (
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {value}
        </Typography>
      ) : (
        value
      )}
    </Box>
  </Box>
);

export default function EventDataDetails({ data }) {
  return (
    <Card
      sx={{
        borderRadius: 2,
        p: 2,
        background: "#fdfdff",
        variant: "outlined",
        width: "100%",
      }}
    >
      <CardContent>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: 3,
          }}
        >
          <Box>
            {/* UBICACIÓN */}
            <Grid item xs={8} md={6}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                {localize.location}
              </Typography>

              <InfoItem
                icon={<LocationOnIcon color="primary" />}
                label={localize.address}
                value={data?.address}
              />

              <InfoItem
                icon={<LocationOnIcon color="primary" />}
                label={localize.city}
                value={data?.city}
              />

              <InfoItem
                icon={<LocationOnIcon color="primary" />}
                label={localize.department}
                value={data?.department}
              />
            </Grid>
          </Box>

          <Box>
            {/* CONTACTO */}
            <Grid item xs={8} md={6}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                {localize.contact}
              </Typography>

              <InfoItem
                icon={<PhoneIcon color="success" />}
                label={localize.phone_number}
                value={data?.phoneNumber}
              />

              <InfoItem
                icon={<EmailIcon color="secondary" />}
                label={localize.email}
                value={data?.email}
              />

              <InfoItem
                icon={<PersonIcon />}
                label={localize.reported_by}
                value={data?.reportedBy}
              />
            </Grid>
          </Box>

          <Box>
            {/* ASIGNACIÓN */}
            <Grid item xs={8} md={6}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                {localize.assignment}
              </Typography>

              <InfoItem
                icon={<AssignmentIndIcon color="info" />}
                label={localize.assigned_to}
                value={data?.assignedTo}
                isComponent
              />

              <InfoItem
                icon={<PersonIcon />}
                label={localize.assigned_by}
                value={data?.assignedBy}
              />

              <InfoItem
                icon={<TimeToLeave />}
                label={localize.vehicle}
                value={data?.vehicle}
              />

              <InfoItem
                icon={<PersonIcon />}
                label={localize.driver}
                value={data?.driver}
              />
            </Grid>
          </Box>

          <Box>
            {/* FECHAS */}
            <Grid item xs={8} md={6}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                {localize.dates}
              </Typography>

              <InfoItem
                icon={<EventIcon color="warning" />}
                label={localize.expected_attention_date}
                value={data?.expectedAttentionDate}
              />

              <InfoItem
                icon={<EventIcon />}
                label={localize.creation_date}
                value={data?.creationDate}
              />

              <InfoItem
                icon={<UpdateIcon />}
                label={localize.modification_date}
                value={data?.modificationDate}
              />

              <InfoItem
                icon={<PersonIcon />}
                label={localize.modified_by}
                value={data?.modifiedBy}
              />
            </Grid>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
